import { Button } from 'antd';
import { useDisclosure } from '@/hooks';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { useWorkorderForms } from '../../WorkOrderFormProvider';
import ComplementCloseProvider from '../ComplementCloseModal/ComplementCloseProvider';
import ComplementClose from './index';

const ComplementCloseFromDetail: React.FC = () => {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();
  const { forms } = useWorkorderForms();
  const [opened, action] = useDisclosure(false);

  return (
    <>
      <Button
        disabled={!hasPermissions([Authorities.MOVIMENTATION_WORKORDER_CLOSE])}
        block
        type="primary"
        onClick={action.open}
        id="workorder-complement-close"
      >
        Fechar O.S.
      </Button>

      {opened && workorder?.id && complement?.id && (
        <ComplementCloseProvider
          workOrderId={workorder.id}
          complementId={complement.id}
        >
          <ComplementClose
            open={opened}
            onClose={action.close}
            forms={forms}
          />
        </ComplementCloseProvider>
      )}
    </>
  );
};

export default ComplementCloseFromDetail;
